module.exports = "<h2 style=\"text-align:center\" i18n=\"message | a message to let the user know the login failed\">\r\n  NOM 151\r\n</h2>\r\n<hr/>\r\n<mat-dialog-content>\r\n  <p>{{nomCert}}</p>\r\n</mat-dialog-content>\r\n<hr/>\r\n<div>\r\n  <button style=\"float:right\" mat-button color=\"primary\" (click)=\"onNoClick()\"> Close </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/documentDetail/nom-151-dialog-component.html
// module id = ../../../../../src/app/components/documentDetail/nom-151-dialog-component.html
// module chunks = main